import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Checkbox,
  Input,
  Button,
  Stack,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Textarea,
  Spinner,
  FormControl,
  FormLabel,
  InputLeftElement,
  InputGroup,
  useToast,
  Icon,
  Flex,
  HStack,
  SimpleGrid,
  IconButton,
  Skeleton,
  Card,
} from '@chakra-ui/react';
import { SearchIcon, ArrowUpIcon, DownloadIcon } from '@chakra-ui/icons';
import { ViewIcon } from '@chakra-ui/icons';
import axios from 'axios';
import baseUrl from 'Base_Url/baseUrl';
import { useColorModeValue } from '@chakra-ui/react';
import moment from 'moment';
import { MdClear } from 'react-icons/md';
import { MdLocationOn, MdInfo, MdImage } from 'react-icons/md';
import { Divider } from 'antd';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
  FaMapMarkerAlt,
  FaLandmark,
  FaUserShield,
  FaTools,
  FaHourglassHalf,
} from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SurveyDetailsModal from './SurveyDetailModal';
import BulkUploadModal from './BulkUploadModal';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { Wrap, WrapItem } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useColorMode } from '@chakra-ui/react';
import { Select } from 'antd';
import { useDispatch } from 'react-redux';
import { fetchSurveyStats } from '../../../redux/slices/surveyStatsSlice';
import { FiCalendar } from 'react-icons/fi';
import { MdStraighten } from 'react-icons/md';
import { useRef } from 'react';
import { FaRulerCombined } from 'react-icons/fa';
import axiosInstance from 'axiosInstance';
import Swal from 'sweetalert2';
import { FaClipboardList } from 'react-icons/fa';
import { FaCheckCircle, FaTimesCircle, FaClock, FaList } from 'react-icons/fa';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import './index.css';

const tbodyVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.8,
      // when: 'beforeChildren',
    },
  },
};

const rowVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
};

export default function AnalyticsPage() {
  const MotionBox = motion(Box);
  const [surveyData, setSurveyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const defaultStatus = searchParams.get('status') || '';
  const [selectedSurveyIds, setSelectedSurveyIds] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [remark, setRemark] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [totalResult, setTotalResult] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [selectedIds, setSelectedIds] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);
  const [isDownloadingKml, setIsDownloadingKml] = useState(false);

  const bgColor = useColorModeValue('white', 'gray.700');
  const color = useColorModeValue('gray.800', 'gray.100');
  const colorBlack = useColorModeValue('black', 'white');
  const { colorMode } = useColorMode();
  const rowBgApproved = useColorModeValue('#d4edda', '#22543D');
  const rowBgRejected = useColorModeValue('#f8d7da', '#742A2A');
  const rowBgPending = useColorModeValue('#d1ecf1', '#2A4365');
  const rowBgAlternate = useColorModeValue('#ECF8FF', '#1A202C');
  const rowBgDefault = useColorModeValue('white', '#171923');
  const headerGradient = useColorModeValue(
    'linear(to-r, blue.400, green.400)',
    'linear(to-r, blue.600, green.600)',
  );
  const tableBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'gray.100');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const getParam = (key, fallback = '') => searchParams.get(key) || fallback;
  const getArrayParam = (key) => {
    const param = searchParams.get(key);
    return param ? JSON.parse(decodeURIComponent(param)) : [];
  };
  const [areaRange, setAreaRange] = useState({
    min: getParam('areaMin'),
    max: getParam('areaMax'),
  });

  const [categoryFilter, setCategoryFilter] = useState(
    getArrayParam('category'),
  );
  const [typeOfEncroachmentFilter, setTypeOfEncroachmentFilter] = useState(
    getArrayParam('encroachments'),
  );
  const toast = useToast();

  const user = useMemo(() => JSON.parse(localStorage.getItem('user')), []);
  console.log('user', user);
  const token = useMemo(() => localStorage.getItem('token'), []);

  const navigate = useNavigate();

  const [searchInput, setSearchInput] = useState(getParam('search') || '');
  const [statusFilter, setStatusFilter] = useState(getParam('status') || '');
  const [startDate, setStartDate] = useState(getParam('startDate') || '');
  const [endDate, setEndDate] = useState(getParam('endDate') || '');
  const [page, setPage] = useState(parseInt(getParam('page')) || 1);
  const endDateRef = useRef(null);

  const [comparisonData, setComparisonData] = useState(null);

  useEffect(() => {
    try {
      const encParam = searchParams.get('encroachments');
      const parsedEncroachments = encParam ? JSON.parse(encParam) : [];
      if (parsedEncroachments.length > 0) {
        setTypeOfEncroachmentFilter(parsedEncroachments);
      }

      const catParam = searchParams.get('category');
      const parsedCategory = catParam ? JSON.parse(catParam) : [];
      if (parsedCategory.length > 0) {
        setCategoryFilter(parsedCategory);
      }

      const areaMin = searchParams.get('minEncroachedArea');
      const areaMax = searchParams.get('maxEncroachedArea');
      if (areaMin || areaMax) {
        setAreaRange({
          min: areaMin || '',
          max: areaMax || '',
        });
      }

      const statusParam = searchParams.get('status');
      if (statusParam) {
        setStatusFilter(statusParam);
      }

      const start = searchParams.get('startDate');
      const end = searchParams.get('endDate');
      if (start && end) {
        setStartDate(moment(start).toDate());
        setEndDate(moment(end).toDate());
      }

      const searchStr = searchParams.get('search');
      if (searchStr) {
        setSearchInput(searchStr);
      }
    } catch (err) {
      console.error('Failed to parse filters from URL:', err);
    }
  }, []);

  const syncUrlParams = ({
    search = '',
    status = '',
    startDate = '',
    endDate = '',
    page = 1,
    minArea = '',
    maxArea = '',
    category = [],
    encroachments = [],
  }) => {
    const newParams = new URLSearchParams();

    if (search) newParams.set('search', search);
    if (status) newParams.set('status', status);
    if (startDate) newParams.set('startDate', startDate);
    if (endDate) newParams.set('endDate', endDate);
    if (page && page !== 1) newParams.set('page', page);
    else newParams.delete('page');
    if (minArea) newParams.set('minArea', minArea);
    if (maxArea) newParams.set('maxArea', maxArea);
    if (category.length > 0)
      newParams.set('category', JSON.stringify(category));
    if (encroachments.length > 0)
      newParams.set('encroachments', JSON.stringify(encroachments));

    setSearchParams(newParams);
  };

  useEffect(() => {
    const pageParam = parseInt(searchParams.get('page')) || 1;
    const search = searchParams.get('search') || '';
    const status = searchParams.get('status') || '';
    const start = searchParams.get('startDate') || '';
    const end = searchParams.get('endDate') || '';
    const minArea = searchParams.get('minArea') || '';
    const maxArea = searchParams.get('maxArea') || '';

    let category = [];
    try {
      category = JSON.parse(searchParams.get('category')) || [];
    } catch (e) {
      category = [];
    }

    let encroachments = [];
    try {
      encroachments = JSON.parse(searchParams.get('encroachments')) || [];
    } catch (e) {
      encroachments = [];
    }

    if (page !== pageParam) setPage(pageParam);
    if (searchInput !== search) setSearchInput(search);
    if (searchTerm !== search) setSearchTerm(search);
    if (statusFilter !== status) setStatusFilter(status);
    if (startDate !== start) setStartDate(start);
    if (endDate !== end) setEndDate(end);
    if (areaRange.min !== minArea || areaRange.max !== maxArea) {
      setAreaRange({ min: minArea, max: maxArea });
    }
    if (JSON.stringify(categoryFilter) !== JSON.stringify(category)) {
      setCategoryFilter(category);
    }
    if (
      JSON.stringify(typeOfEncroachmentFilter) !== JSON.stringify(encroachments)
    ) {
      setTypeOfEncroachmentFilter(encroachments);
    }
  }, [searchParams]);

  useEffect(() => {
    const pageParam = parseInt(searchParams.get('page'));
    if (!isNaN(pageParam) && pageParam !== page) {
      setPage(pageParam);
    }
  }, [searchParams.get('page')]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      setPage(1);
      syncUrlParams({
        search: searchInput,
        status: statusFilter,
        startDate,
        endDate,
        page: 1,
        minArea: areaRange.min,
        maxArea: areaRange.max,
        category: categoryFilter,
        encroachments: typeOfEncroachmentFilter,
      });
    }, 500);
    return () => clearTimeout(debounce);
  }, [
    searchInput,
    statusFilter,
    startDate,
    endDate,
    areaRange.min,
    areaRange.max,
    categoryFilter,
    typeOfEncroachmentFilter,
  ]);

  const {
    isOpen: isUploadModal2Open,
    onOpen: onUploadModal2Open,
    onClose: onUploadModal2Close,
  } = useDisclosure();

  const filteredData = useMemo(() => surveyData, [surveyData]);

  const getQueryString = useCallback((params) => {
    return Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== '')
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
  }, []);

  const queryParams = useMemo(() => {
    const params = { page, limit: rowsPerPage };
    const filter = {};

    if (searchInput) filter.searchString = searchInput;

    if (startDate && endDate) {
      filter.startDate = moment(startDate).format('YYYY-MM-DD');
      filter.endDate = moment(endDate).format('YYYY-MM-DD');
    }

    if (statusFilter && statusFilter !== 'All') {
      filter.status = statusFilter;
    }

    if (areaRange.min) filter.minEncroachedArea = areaRange.min;
    if (areaRange.max) filter.maxEncroachedArea = areaRange.max;

    if (categoryFilter.length > 0) {
      filter.category = categoryFilter;
    }

    if (typeOfEncroachmentFilter.length > 0) {
      filter.typeOfEncroachment = typeOfEncroachmentFilter;
    }

    if (Object.keys(filter).length > 0) {
      params.filter = JSON.stringify(filter);
    }

    return params;
  }, [
    page,
    rowsPerPage,
    searchInput,
    startDate,
    endDate,
    statusFilter,
    areaRange,
    categoryFilter,
    typeOfEncroachmentFilter,
  ]);

  const queryParamsforExcelData = useMemo(() => {
    const params = {};
    const filter = {};

    const search = searchParams.get('search') || '';
    const status = searchParams.get('status') || '';
    const start = searchParams.get('startDate') || '';
    const end = searchParams.get('endDate') || '';
    const minArea = searchParams.get('minArea') || '';
    const maxArea = searchParams.get('maxArea') || '';

    let category = [];
    try {
      category = JSON.parse(searchParams.get('category')) || [];
    } catch (e) {}

    let encroachments = [];
    try {
      encroachments = JSON.parse(searchParams.get('encroachments')) || [];
    } catch (e) {}

    if (search) filter.searchString = search;
    if (status && status !== 'All') filter.status = status;
    if (start && end) {
      filter.startDate = moment(start).format('YYYY-MM-DD');
      filter.endDate = moment(end).format('YYYY-MM-DD');
    }
    if (minArea) filter.minEncroachedArea = minArea;
    if (maxArea) filter.maxEncroachedArea = maxArea;
    if (category.length > 0) filter.category = category;
    if (encroachments.length > 0) filter.typeOfEncroachment = encroachments;

    if (Object.keys(filter).length > 0) {
      params.filter = JSON.stringify(filter);
    }

    console.log(filter, 'Filter Data for Excel');
    return params;
  }, [searchParams]);

  const fetchSurveys = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${baseUrl}/survey/all-surveys?${getQueryString(queryParams)}`,
        {
          headers: {
            Authorization: `Bearer ${token} `,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      const result = response.data.data;
      const data = Array.isArray(result.data) ? result.data : [];

      setSurveyData(data);
      setPage(result.page);
      setTotalPages(result.totalPages);
      setTotalResult(result.totalResults);
    } catch (err) {
      setError(`Failed to fetch survey data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }, [queryParams, token]);

  const fetchComparisonSurvey = useCallback(
    async (surveyId) => {
      setLoading(true);
      try {
        const response = await axios.get(
          ` ${baseUrl}/survey/get-comparison-survey/${surveyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const result = response?.data?.data;

        if (!result) {
          console.warn('No valid comparison data returned.');
          return null;
        }

        return result;
      } catch (err) {
        setError(`Failed to fetch comparison data: ${err.message}`);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [token],
  );

  useEffect(() => {
    fetchSurveys();
  }, [
    fetchSurveys,
    searchInput,
    statusFilter,
    startDate,
    endDate,
    areaRange.min,
    areaRange.max,
    categoryFilter,
    typeOfEncroachmentFilter,
    page,
    rowsPerPage,
  ]);

  const handleViewClick = useCallback(
    async (survey) => {
      setSelectedSurvey(survey);
      setRemark('');
      onOpen(true);

      if (survey.status === 'pending') {
        const surveyId = survey?.surveyId;
        console.log('survey ', survey);

        try {
          const comparison = await fetchComparisonSurvey(surveyId);

          if (!comparison) {
            setComparisonData(null);
          } else {
            setComparisonData(comparison);
          }
        } catch (err) {
          console.error('Failed to fetch comparison survey:', err);
        }
      } else {
        setComparisonData(null);
      }
    },
    [onOpen, fetchComparisonSurvey],
  );

  const handleBulkApprove = useCallback(async () => {
    if (selectedSurveyIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are approving ${selectedSurveyIds.length} selected surveys.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, approve',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    try {
      await axios.put(
        `${baseUrl}/survey/update-multiple`,
        { surveyIds: selectedSurveyIds, status: 'approved' },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      toast({
        title: 'Selected surveys approved.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      setSelectedSurveyIds([]);
      onClose();
      fetchSurveys();
      dispatch(fetchSurveyStats());
    } catch (err) {
      toast({
        title: 'Approval failed.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [selectedSurveyIds, token, toast, fetchSurveys, onClose, dispatch]);

  const handleBulkReject = useCallback(async () => {
    if (selectedSurveyIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to reject ${selectedSurveyIds.length} selected surveys.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e53e3e', // Chakra's red.500
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, reject',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    try {
      await axiosInstance.put(
        `${baseUrl}/survey/update-multiple`,
        { surveyIds: selectedSurveyIds, status: 'rejected' },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      toast({
        title: 'Selected surveys rejected.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      setSelectedSurveyIds([]);
      onClose();
      fetchSurveys();
      dispatch(fetchSurveyStats());
    } catch (err) {
      toast({
        title: 'Rejection failed.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [selectedSurveyIds, token, toast, fetchSurveys, onClose, dispatch]);

  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadFormat = useCallback(async () => {
    setIsDownloading(true);
    try {
      const res = await axios.get(`${baseUrl}/survey/download-xlsx`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
        params: queryParamsforExcelData,
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Bulk-Survey-Format.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      Swal.fire({
        icon: 'success',
        title: 'Downloaded!',
        text: 'The Bulk Survey Format has been downloaded successfully.',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Download Failed',
        text: 'Failed to download the survey format. Please try again.',
      });
    } finally {
      setIsDownloading(false);
    }
  }, [token, queryParamsforExcelData]);

  const [isExporting, setIsExporting] = useState(false);

  const handleDownloadExcel = useCallback(async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to export the data to Excel?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Yes, export it!',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    setIsExporting(true);
    try {
      const response = await axios.get(`${baseUrl}/survey/export-excel-file`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
        params: queryParamsforExcelData,
      });

      if (response.status === 404 || response.status === 201) {
        toast({
          title: 'No survey data found to export.',
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
        setIsExporting(false);
        return;
      }

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `encroachment-data-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire('Success!', 'Excel file exported successfully.', 'success');
    } catch (error) {
      toast({
        title: error?.response?.data?.message
          ? error?.response?.data?.message
          : error?.response?.data?.data || 'Excel download failed.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
    setIsExporting(false);
  }, [token, toast, queryParamsforExcelData]);

  const downloadPDF = useCallback(
    async (ids) => {
      if (!ids || ids.length === 0) return;

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `You are about to download ${
          ids.length > 1 ? 'multiple surveys as a ZIP' : 'this survey as a PDF'
        }.`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#15842bff',
        cancelButtonColor: '#aaa',
        confirmButtonText: 'Yes, download',
        cancelButtonText: 'Cancel',
      });

      if (!result.isConfirmed) return;

      try {
        setDownloading(true);

        const response = await axios.post(
          `${baseUrl}/survey/export-pdf-file`,
          { ids },
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: 'blob',
          },
        );

        const isZip = ids.length > 1;
        const mimeType = isZip ? 'application/zip' : 'application/pdf';
        const fileName = isZip
          ? `surveys-${Date.now()}.zip`
          : `survey-${Date.now()}.pdf`;

        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        toast({
          title: 'Download failed',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setDownloading(false);
      }
    },
    [token, toast],
  );

  const handlePageChange = useCallback(
    (newPage) => {
      setPage(newPage);
      syncUrlParams({
        search: searchInput,
        status: statusFilter,
        startDate,
        endDate,
        page: newPage,
        minArea: areaRange.min,
        maxArea: areaRange.max,
        category: categoryFilter,
        encroachments: typeOfEncroachmentFilter,
      });
    },
    [
      searchInput,
      statusFilter,
      startDate,
      endDate,
      areaRange,
      categoryFilter,
      typeOfEncroachmentFilter,
    ],
  );

  const handleStatusChange = (newStatus) => {
    setStatusFilter(newStatus);
    setPage(1);
    syncUrlParams({
      search: searchTerm,
      status: newStatus,
      startDate,
      endDate,
      page: 1,
    });
  };

  const renderPagination = () => {
    const maxPagesToShow = 5;
    const pages = [];
    const isEllipsisShown = totalPages > maxPagesToShow;

    const createPageButton = (pageNumber) => (
      <Button
        key={pageNumber}
        onClick={() => handlePageChange(pageNumber)}
        colorScheme={page === pageNumber ? 'blue' : 'gray'}
        variant={page === pageNumber ? 'solid' : 'outline'}
        mx="1"
      >
        {pageNumber}
      </Button>
    );

    if (isEllipsisShown) {
      if (page > Math.ceil(maxPagesToShow / 2)) {
        pages.push(createPageButton(1));
        pages.push(
          <Text key="ellipsis-start" mx="1" fontSize="lg">
            ...
          </Text>,
        );
      }

      const startPage = Math.max(page - Math.floor(maxPagesToShow / 2), 1);
      const endPage = Math.min(
        page + Math.floor(maxPagesToShow / 2),
        totalPages,
      );
      for (let i = startPage; i <= endPage; i++) {
        pages.push(createPageButton(i));
      }

      if (page < totalPages - Math.floor(maxPagesToShow / 2)) {
        pages.push(
          <Text key="ellipsis-end" mx="1" fontSize="lg">
            ...
          </Text>,
        );
        pages.push(createPageButton(totalPages));
      }
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(createPageButton(i));
      }
    }

    return (
      <Flex mt="4" justify="center" align="center">
        <IconButton
          aria-label="Previous Page"
          icon={<ChevronLeftIcon />}
          isDisabled={page <= 1}
          onClick={() => handlePageChange(page - 1)}
          mr="2"
        />
        {pages}
        <IconButton
          aria-label="Next Page"
          icon={<ChevronRightIcon />}
          isDisabled={page >= totalPages}
          onClick={() => handlePageChange(page + 1)}
          ml="2"
        />
      </Flex>
    );
  };

  const inputBgColor = useColorModeValue('white', 'gray.700');
  const inputTextColor = useColorModeValue('gray.800', 'white');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');
  const iconColor = useColorModeValue('gray.400', 'gray.300');

  // const handleDownloadKml = async () => {
  //   try {
  //     const token = localStorage.getItem('token');
  //     const res = await fetch(`${baseUrl}/survey/get-kml`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });

  //     const json = await res.json();
  //     console.log('API Response:', json);

  //     if (!json?.data?.length) {
  //       alert('No KML file available on server');
  //       return;
  //     }

  //     json.data.forEach((item) => {
  //       console.log("item", item)
  //       const filePath = item.file;
  //       const fileName = filePath.split('\\').pop();
  //       const downloadUrl = `${baseUrl}/uploads${fileName}`;

  //       const link = document.createElement('a');
  //       link.href = downloadUrl;
  //       link.download = fileName;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     });
  //   } catch (err) {
  //     console.error('Download error:', err);
  //     alert('Download failed');
  //   }
  // };

    const handleDownloadKml = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${baseUrl}/survey/get-kml`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const json = await res.json();
      console.log("API Response:", json);

      if (!json?.data?.length) {
        alert("No KML file available on server");
        return;
      }

      json.data.forEach((item) => {
        const filePath = item.file;
        const fileName = filePath.split("\\").pop();
        // const downloadUrl = `${baseUrl}/uploads/surveys/${fileName}`; local server path
        const downloadUrl = `${baseUrl}/${fileName}`;

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });

    } catch (err) {
      console.error("Download error:", err);
      alert("Download failed");
    }
  };

  return (
    <Box pt={{ base: '140px', md: '90px' }} px={{ base: '4', md: '8' }}>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ base: 'start', md: 'center' }}
        gap={4}
        mb={4}
      >
        <Text
          fontSize="xl"
          fontWeight="bold"
          display="inline-flex"
          alignItems="center"
          gap={2}
        >
          <Box color="#4B80DE">
            <FaClipboardList />
          </Box>
          All Surveys
        </Text>

        <Wrap
          spacing={2}
          justify={{ base: 'start', md: 'end' }}
          flexWrap="wrap"
        >
          {user.role === 'tahsildar' && (
            <WrapItem>
              <Button
                size="sm"
                leftIcon={<DownloadIcon />}
                colorScheme="blue"
                onClick={handleDownloadKml}
                isLoading={isDownloadingKml}
                loadingText="Downloading"
              >
                Download KML
              </Button>
            </WrapItem>
          )}
          <WrapItem>
            <Button
              size="sm"
              leftIcon={<DownloadIcon />}
              colorScheme="pink"
              onClick={handleDownloadExcel}
              isLoading={isExporting}
              loadingText="Exporting"
            >
              Export To Excel
            </Button>
          </WrapItem>
          {selectedSurveyIds.length > 0 && (
            <WrapItem>
              <HStack spacing={2}>
                <Button
                  size="sm"
                  colorScheme="green"
                  onClick={handleBulkApprove}
                  leftIcon={<CheckIcon />}
                >
                  Bulk Approve ({selectedSurveyIds.length})
                </Button>
                <Button
                  size="sm"
                  colorScheme="red"
                  onClick={handleBulkReject}
                  leftIcon={<CloseIcon />}
                >
                  Bulk Reject ({selectedSurveyIds.length})
                </Button>
              </HStack>
            </WrapItem>
          )}
          {user?.role === 'collector' && (
            <>
              <Wrap spacing={4}>
                <WrapItem>
                  <Button
                    size="sm"
                    leftIcon={<DownloadIcon />}
                    colorScheme="purple"
                    onClick={handleDownloadFormat}
                    isLoading={isDownloading}
                    loadingText="Downloading"
                  >
                    Download Historic Data Format
                  </Button>
                </WrapItem>
                <WrapItem>
                  <Button
                    size="sm"
                    leftIcon={<ArrowUpIcon />}
                    colorScheme="red"
                    onClick={onUploadModal2Open}
                  >
                    Upload Historic Data
                  </Button>
                </WrapItem>
              </Wrap>
            </>
          )}
          {selectedIds.length > 0 && (
            <WrapItem>
              <Button
                size="sm"
                leftIcon={downloading ? <Spinner size="sm" /> : <FiDownload />}
                onClick={() => {
                  const pendingItems = surveyData.filter(
                    (item) =>
                      selectedIds.includes(item._id) &&
                      item.status !== 'approved',
                  );

                  if (pendingItems.length > 0) {
                    toast({
                      title: 'Only approved surveys can be downloaded.',
                      description: `${pendingItems.length} selected item(s) are not approved.`,
                      status: 'warning',
                      duration: 4000,
                      isClosable: true,
                    });
                    return;
                  }

                  downloadPDF(selectedIds);
                }}
                colorScheme="green"
                isDisabled={downloading}
              >
                {downloading
                  ? 'Downloading...'
                  : `Download PDF Selected (${selectedIds.length})`}
              </Button>
            </WrapItem>
          )}
        </Wrap>
      </Flex>

      {/* <Accordion defaultIndex={[0]} allowToggle mb={4}>
        <AccordionItem
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          overflow="visible"
          bg={bgColor}
          boxShadow="sm"
        >
          <h2>
            <AccordionButton
              px={4}
              py={3}
              _expanded={{ bg: 'pink.50', color: 'pink.600' }}
              _hover={{ bg: 'gray.50' }}
            >
              <Box
                flex="1"
                textAlign="left"
                fontWeight="semibold"
                fontSize="md"
              >
                Filters
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel
            px={4}
            pt={4}
            pb={2}
            bg={bgColor}
            sx={{
              overflow: 'visible',
            }}
          ></AccordionPanel>
        </AccordionItem>
      </Accordion> */}

      <Stack mb={4} spacing={4} w="100%">
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 2, lg: 3 }}
          spacing={{ base: 3, md: 4 }}
          w="100%"
        >
          <InputGroup size="sm">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color={color} />
            </InputLeftElement>
            <Input
              bg={inputBgColor}
              color={inputTextColor}
              _placeholder={{ color: placeholderColor }}
              placeholder="Search Here By Name, Village, Taluka, Gat No..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              aria-label="Search Input"
            />
          </InputGroup>

          <Flex align="center" gap={2}>
            <Box zIndex={999} position="relative">
              <FormControl>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" height="100%" pl={3}>
                    <Icon as={FiCalendar} color={iconColor} boxSize={4} />
                  </InputLeftElement>
                  <DatePicker
                    selected={startDate ? new Date(startDate) : null}
                    onChange={(date) => {
                      if (!date) return setStartDate('');
                      const formatted = moment(date).format('YYYY-MM-DD');
                      setStartDate(formatted);
                      if (endDate && new Date(formatted) > new Date(endDate)) {
                        setEndDate('');
                      }
                      if (endDateRef.current) {
                        endDateRef.current.setFocus();
                      }
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Start Date"
                    maxDate={new Date()}
                    customInput={
                      <Input
                        size="sm"
                        bg={bgColor}
                        color={textColor}
                        _placeholder={{ color: placeholderColor }}
                        pl={10}
                        height="34px"
                      />
                    }
                  />
                </InputGroup>
              </FormControl>
            </Box>

            <Text fontSize="sm" my={2} textAlign="center">
              to
            </Text>
            <Box zIndex={9} position="relative">
              <FormControl>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" height="100%" pl={3}>
                    <Icon as={FiCalendar} color={color} boxSize={4} />
                  </InputLeftElement>

                  <DatePicker
                    selected={endDate ? new Date(endDate) : null}
                    onChange={(date) => {
                      if (!date) return setEndDate('');
                      const formatted = moment(date).format('YYYY-MM-DD');
                      if (
                        startDate &&
                        new Date(formatted) < new Date(startDate)
                      ) {
                        toast({
                          title: 'Invalid end date',
                          description: 'End date cannot be before start date',
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return;
                      }
                      setEndDate(formatted);
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="End Date"
                    disabled={!startDate}
                    maxDate={startDate ? new Date(startDate) : new Date()}
                    customInput={
                      <Input
                        size="sm"
                        bg={bgColor}
                        pl={10}
                        height="34px"
                        color={textColor}
                        _placeholder={{ color: placeholderColor }}
                      />
                    }
                  />
                </InputGroup>
              </FormControl>
            </Box>
          </Flex>

          <HStack spacing={2}>
            <FormControl>
              <InputGroup>
                <InputLeftElement pointerEvents="none" pl={2}>
                  <Icon as={MdStraighten} color={color} boxSize={4} mb={2} />
                </InputLeftElement>
                <Input
                  size="sm"
                  type="number"
                  placeholder="Min Area in Hectares"
                  value={areaRange.min}
                  bg={bgColor}
                  pl={10}
                  color={textColor}
                  _placeholder={{ color: placeholderColor }}
                  onChange={(e) =>
                    setAreaRange((prev) => ({
                      ...prev,
                      min: e.target.value,
                    }))
                  }
                />
              </InputGroup>
            </FormControl>

            <Text fontSize="sm" textAlign="center" my={2}>
              to
            </Text>

            <FormControl>
              <InputGroup>
                <InputLeftElement pointerEvents="none" pl={2}>
                  <Icon as={MdStraighten} color={color} boxSize={4} mb={2} />
                </InputLeftElement>
                <Input
                  size="sm"
                  type="number"
                  placeholder="Max Area in Hectares"
                  value={areaRange.max}
                  bg={bgColor}
                  color={textColor}
                  _placeholder={{ color: placeholderColor }}
                  pl={10}
                  disabled={!areaRange.min || areaRange.min === ''}
                  onChange={(e) =>
                    setAreaRange((prev) => ({
                      ...prev,
                      max: e.target.value,
                    }))
                  }
                />
              </InputGroup>
            </FormControl>
          </HStack>

          <FormControl>
            <Select
              mode="multiple"
              allowClear
              size="small"
              placeholder="Filter by Caste"
              value={categoryFilter}
              onChange={(values) => setCategoryFilter(values)}
              className={colorMode === 'dark' ? 'ant-select-dark' : ''}
              style={{ width: '100%' }}
              options={[
                'SC',
                'ST',
                'OBC',
                'VJNT',
                'SBC',
                'OPEN',
                'NT-A',
                'NT-B',
                'NT-C',
                'NT-D',
                'Other',
              ].map((val) => ({ value: val, label: val }))}
            />
          </FormControl>

          <FormControl>
            <Select
              mode="multiple"
              allowClear
              size="small"
              placeholder="Type of Encroachment"
              className={colorMode === 'dark' ? 'ant-select-dark' : ''}
              value={typeOfEncroachmentFilter}
              onChange={(values) => setTypeOfEncroachmentFilter(values)}
              style={{ width: '100%' }}
              zIndex={0}
              options={[
                { value: 'rawHouse', label: 'Raw House' },
                { value: 'tinShed', label: 'Concrete House' },
                { value: 'slum', label: 'Slum' },
                {
                  value: 'govtEmployeesColony',
                  label: 'Govt. Employees Colony',
                },
                { value: 'govtSchool', label: 'Govt. School' },
                { value: 'privateSchool', label: 'Private School' },
                {
                  value: 'commercialTemporary',
                  label: 'Commercial (Temporary)',
                },
                {
                  value: 'commercialPermanent',
                  label: 'Commercial (Permanent)',
                },
                { value: 'mall', label: 'Mall and Mall Like' },
                { value: 'publicUtilities', label: 'Public Utilities' },
                { value: 'publicPurpose', label: 'Public Purpose' },
                { value: 'agriculture', label: 'Agriculture' },
                { value: 'other', label: 'Other' },
              ]}
            />
          </FormControl>

          <Wrap spacing={2}>
            {['All', 'pending', 'approved', 'rejected'].map((status) => {
              const isActive =
                statusFilter === status ||
                (status === 'All' && statusFilter === '');

              const getIcon = (status) => {
                switch (status) {
                  case 'pending':
                    return <FaHourglassHalf />;
                  case 'approved':
                    return <FaCheckCircle />;
                  case 'rejected':
                    return <FaTimesCircle />;
                  default:
                    return null;
                }
              };

              return (
                <WrapItem key={status}>
                  <Button
                    size="xs"
                    fontSize="xs"
                    variant={isActive ? 'solid' : 'outline'}
                    colorScheme={
                      status === 'approved'
                        ? 'green'
                        : status === 'rejected'
                        ? 'red'
                        : status === 'pending'
                        ? 'orange'
                        : 'blue'
                    }
                    onClick={() =>
                      handleStatusChange(status === 'All' ? '' : status)
                    }
                    leftIcon={status !== 'All' ? getIcon(status) : undefined}
                  >
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </Button>
                </WrapItem>
              );
            })}
                     
          </Wrap>
        </SimpleGrid>
      </Stack>

      {(searchInput.trim() !== '' ||
        statusFilter !== '' ||
        startDate !== '' ||
        endDate !== '' ||
        areaRange.min !== '' ||
        areaRange.max !== '' ||
        categoryFilter.length > 0 ||
        typeOfEncroachmentFilter.length > 0) && (
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button
            size="sm"
            leftIcon={<MdClear />}
            colorScheme="red"
            variant="solid"
            onClick={() => {
              setSearchInput('');
              setStatusFilter('');
              setStartDate('');
              setEndDate('');
              setPage(1);
              setSearchParams({});
              setAreaRange({ min: '', max: '' });
              setCategoryFilter([]);
              setTypeOfEncroachmentFilter([]);
            }}
          >
            Clear Filters
          </Button>
        </Box>
      )}
      <Card
        flexDirection="column"
        w="100%"
        px="0px"
        overflowX="auto"
        pt="0"
        mt="0"
      >
        <Box
          w="100%"
          overflowX="auto"
          borderRadius="md"
          boxShadow="md"
          maxHeight="60vh"
          bg={tableBg}
        >
          <Table
            size={'sm'}
            variant="simple"
            minW="1200px"
            sx={{
              'th, td': {
                borderColor: borderColor,
                color: textColor,
              },
            }}
          >
            <Thead
              position="sticky"
              top={0}
              zIndex={1}
              bgGradient={headerGradient}
            >
              <Tr>
                <Th color="white" whiteSpace="nowrap">
                  {user?.role === 'tahsildar' && (
                    <Checkbox
                      colorScheme="green"
                      // border="black"
                      onClick={(e) => e.stopPropagation()}
                      isChecked={
                        filteredData.filter((row) => row.status === 'pending')
                          .length > 0 &&
                        selectedSurveyIds.length ===
                          filteredData.filter((row) => row.status === 'pending')
                            .length
                      }
                      isIndeterminate={
                        selectedSurveyIds.length > 0 &&
                        selectedSurveyIds.length <
                          filteredData.filter((row) => row.status === 'pending')
                            .length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedSurveyIds(
                            filteredData
                              .filter((row) => row.status === 'pending')
                              .map((row) => row._id),
                          );
                        } else {
                          setSelectedSurveyIds([]);
                        }
                      }}
                      mx="auto"
                    >
                      <Text fontSize="12" fontWeight="bold">
                        All
                      </Text>
                    </Checkbox>
                  )}
                </Th>

                <Th color="white" whiteSpace="nowrap">
                  <Flex justify="center" align="center" height="100%">
                    Sr. No
                  </Flex>
                </Th>
                <Th color="white" whiteSpace="nowrap">
                  Division
                </Th>
                <Th color="white" whiteSpace="nowrap">
                  District
                </Th>
                <Th color="white" whiteSpace="nowrap">
                  Taluka
                </Th>
                <Th color="white" whiteSpace="nowrap">
                  Village
                </Th>
                <Th color="white" whiteSpace="nowrap">
                  Encroacher Name
                </Th>
                <Th color="white" whiteSpace="nowrap">
                  Encroachment Date
                </Th>
                <Th color="white" whiteSpace="nowrap">
                  Status
                </Th>

                <Th color="white" whiteSpace="nowrap">
                  <Flex justify="center" align="center" height="100%" gap={2}>
                    <Checkbox
                      colorScheme="red"
                      isChecked={
                        selectedIds.length === surveyData.length &&
                        surveyData.length > 0
                      }
                      isIndeterminate={
                        selectedIds.length > 0 &&
                        selectedIds.length < surveyData.length
                      }
                      onChange={(e) => {
                        const checked = e.target.checked;
                        if (checked) {
                          setSelectedIds(
                            surveyData
                              .filter((item) => item.status === 'approved')
                              .map((item) => item._id),
                          );
                        } else {
                          setSelectedIds([]);
                        }
                      }}
                    />
                    Export PDF
                  </Flex>
                </Th>
              </Tr>
            </Thead>
            <motion.tbody
              variants={tbodyVariants}
              initial="hidden"
              animate="visible"
            >
              {loading ? (
                [...Array(6)].map((_, i) => (
                  <Tr key={`skeleton-row-${i}`}>
                    {Array.from({ length: 10 }).map((_, j) => (
                      <Td key={`skeleton-cell-${j}`}>
                        <Skeleton height="16px" width="100%" />
                      </Td>
                    ))}
                  </Tr>
                ))
              ) : error ? (
                <Tr>
                  <Td colSpan={10} textAlign="center">
                    <Text color="red.500">{error}</Text>
                  </Td>
                </Tr>
              ) : filteredData.length === 0 ? (
                <Tr>
                  <Td colSpan={10} textAlign="center">
                    No matching records found.
                  </Td>
                </Tr>
              ) : (
                filteredData.map((row, index) => {
                  const startingSerialNumber = (page - 1) * rowsPerPage + 1;
                  const rowBg =
                    row.status === 'approved'
                      ? rowBgApproved
                      : row.status === 'rejected'
                      ? rowBgRejected
                      : row.status === 'pending'
                      ? rowBgPending
                      : index % 2 === 0
                      ? rowBgAlternate
                      : rowBgDefault;

                  return (
                    <motion.tr
                      key={row._id}
                      variants={rowVariants}
                      style={{ background: rowBg, cursor: 'pointer' }}
                      whileHover={{
                        scale: 1.01,
                        transition: { duration: 0.2 },
                      }}
                      onClick={() => handleViewClick(row)}
                    >
                      <Td py={2} px={3}>
                        {user?.role === 'tahsildar' &&
                        row.status === 'pending' ? (
                          <Flex
                            justify="center"
                            align="center"
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => e.stopPropagation()}
                          >
                            <Checkbox
                              colorScheme="green"
                              border="black"
                              isChecked={selectedSurveyIds.includes(row._id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedSurveyIds((prev) => [
                                    ...prev,
                                    row._id,
                                  ]);
                                } else {
                                  setSelectedSurveyIds((prev) =>
                                    prev.filter((id) => id !== row._id),
                                  );
                                }
                              }}
                            />
                          </Flex>
                        ) : (
                          user?.role === 'tahsildar' && (
                            <Flex justify="center" align="center">
                              <Checkbox isDisabled />
                            </Flex>
                          )
                        )}
                      </Td>

                      <Td py={2} px={3}>
                        <Flex justify="center" align="center" height="100%">
                          {startingSerialNumber + index}
                        </Flex>
                      </Td>

                      <Td py={2} px={3}>
                        {row.division?.name.toUpperCase() || 'N/A'}
                      </Td>
                      <Td py={2} px={3}>
                        {row.district?.name.toUpperCase() || 'N/A'}
                      </Td>
                      <Td py={2} px={3}>
                        {row.tahsil?.name.toUpperCase() || 'N/A'}
                      </Td>
                      <Td py={2} px={3}>
                        {row.village?.name.toUpperCase() || 'N/A'}
                      </Td>
                      <Td py={2} px={3} w={'20%'}>
                        {row.encroacherName?.toUpperCase() || 'N/A'}
                      </Td>
                      <Td py={2} px={3} whiteSpace="nowrap">
                        {moment(row.encroachmentYear).format('DD-MM-YYYY')}
                      </Td>

                      <Td py={2} px={3}>
                        {row.status?.toUpperCase()}
                      </Td>

                      <Td py={2} px={3} onClick={(e) => e.stopPropagation()}>
                        <Flex justify="center" align="center" height="100%">
                          {row.status === 'approved' && (
                            <Flex align="center" gap={2}>
                              <Checkbox
                                iconColor="black"
                                colorScheme="red"
                                borderColor="black"
                                _checked={{
                                  bg: 'black',
                                  borderColor: 'black',
                                  color: 'white',
                                }}
                                isChecked={selectedIds.includes(row._id)}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  const checked = e.target.checked;
                                  setSelectedIds((prev) =>
                                    checked
                                      ? [...prev, row._id]
                                      : prev.filter((id) => id !== row._id),
                                  );
                                }}
                              />
                              {downloadingId === row._id ? (
                                <Spinner size="sm" color={colorBlack} />
                              ) : (
                                <Icon
                                  as={FiDownload}
                                  boxSize={5}
                                  color={colorBlack}
                                  cursor="pointer"
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    setDownloadingId(row._id);
                                    try {
                                      await downloadPDF([row._id]);
                                    } finally {
                                      setDownloadingId(null);
                                    }
                                  }}
                                />
                              )}
                            </Flex>
                          )}
                        </Flex>
                      </Td>
                    </motion.tr>
                  );
                })
              )}
            </motion.tbody>
          </Table>
        </Box>
      </Card>
      {renderPagination()}

      <BulkUploadModal
        isOpen={isUploadModal2Open}
        onClose={onUploadModal2Close}
        uploadFile={uploadFile}
        setUploadFile={setUploadFile}
      />
      <SurveyDetailsModal
        isOpen={isOpen}
        onClose={onClose}
        selectedSurvey={selectedSurvey}
        comparisonData={comparisonData}
        user={user}
        fetchSurveys={fetchSurveys}
      />
    </Box>
  );
}
